// Connect to Azure Application Insights, configure Click Analytics

import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";

const APP_INSIGHTS_KEY = process.env.REACT_APP_APPLICATION_INSIGHTS_KEY;

const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  autoCapture: true,
  //filter out any clicks on links which are not children of the element having the
  // parentDataTag attribute
  dataTags: {
    captureAllMetaDataContent: true,
    useDefaultContentNameOrId: false,
    customDataPrefix: "data-lccbot-",
    parentDataTag: "stop-capture",
  },
  dropInvalidEvents: true,
};

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: APP_INSIGHTS_KEY,
    extensions: [clickPluginInstance],
    extensionConfig: {
      [clickPluginInstance.identifier]: clickPluginConfig,
    },
    // currently no way to filter out errors thrown from other scripts on the page the bot is embedded in
    // like there is for click tracking
    disableExceptionTracking: true
  },
});

appInsights.loadAppInsights();

export { reactPlugin, appInsights };
